// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fuAc","questions":"styles_questions__1clYL","footer":"styles_footer__7zrlF"};